import { jsx as k } from "react/jsx-runtime";
import { h as c, u, a as v } from "./index-6a632112.mjs";
import { s as r } from "./themes-5f0b3c3d.mjs";
import "react";
const o = ["10px", "14px", "18px"];
function C(e) {
  return {
    width: e.width ? `${e.width}px` : "100%",
    height: e.height ? `${e.height}px` : e.$textType === "eyebrow" ? o[0] : e.size ? x(e.$textType || "", e.size) : "max-content"
  };
}
function B(e) {
  return {
    width: e.width ? `${e.width}px` : e.size ? n(e.size) : "max-content",
    height: e.height ? `${e.height}px` : e.size ? n(e.size) : "max-content"
  };
}
const n = (e) => {
  switch (e) {
    case "l":
      return r["12x"];
    case "m":
      return r["10x"];
    case "s":
      return r["8x"];
    case "xs":
      return r["6x"];
  }
  return o[0];
}, x = (e, t) => {
  if (e === "body")
    switch (t) {
      case "l":
        return r["4x"];
      case "m":
        return o[1];
      case "s":
        return r["3x"];
      case "xs":
        return o[0];
      default:
        return o[0];
    }
  switch (t) {
    case "l":
      return o[2];
    case "m":
      return r["4x"];
    case "s":
      return o[1];
    case "xxl":
      return r["7x"];
    case "xl":
      return r["6x"];
    case "xs":
      return r["3x"];
  }
  return o[0];
}, h = c`
  0%, 20% {
    background: linear-gradient(
        -245deg,
        var(--skeletonBgColor1) 0%,
        var(--skeletonBgColor2) 100%
    );
  }
  25% {
    background: linear-gradient(
        -245deg,
        var(--skeletonBgColor1) 0%,
        var(--skeletonBgColor0) 10% 20%,
        var(--skeletonBgColor2) 100%
    );
  }
  30% {
    background: linear-gradient(
        -245deg,
        var(--skeletonBgColor1) 0%,
        var(--skeletonBgColor0) 20% 30%,
        var(--skeletonBgColor2) 100%
    );
  }
  35% {
    background: linear-gradient(
        -245deg,
        var(--skeletonBgColor1) 0%,
        var(--skeletonBgColor0) 30% 40%,
        var(--skeletonBgColor2) 100%
    );
  }
  40% {
    background: linear-gradient(
        -245deg,
        var(--skeletonBgColor1) 0%,
        var(--skeletonBgColor0) 40% 50%,
        var(--skeletonBgColor2) 100%
    );
  }
  45% {
    background: linear-gradient(
        -245deg,
        var(--skeletonBgColor1) 0%,
        var(--skeletonBgColor0) 50% 60%,
        var(--skeletonBgColor2) 100%
    );
  }
  50% {
    background: linear-gradient(
        -245deg,
        var(--skeletonBgColor1) 0%,
        var(--skeletonBgColor0) 60% 70%,
        var(--skeletonBgColor2) 100%
    );
  }
  55% {
    background: linear-gradient(
        -245deg,
        var(--skeletonBgColor1) 0%,
        var(--skeletonBgColor0) 70% 80%,
        var(--skeletonBgColor2) 100%
    );
  }
  60% {
    background: linear-gradient(
        -245deg,
        var(--skeletonBgColor1) 0%,
        var(--skeletonBgColor0) 80% 90%,
        var(--skeletonBgColor2) 100%
    );
  }
  65% {
    background: linear-gradient(
        -245deg,
        var(--skeletonBgColor1) 0%,
        var(--skeletonBgColor0) 90% 100%,
        var(--skeletonBgColor2) 100%
    );
  }
  70%, 100% {
    background: linear-gradient(
        -245deg,
        var(--skeletonBgColor1) 0%,
        var(--skeletonBgColor2) 100%
    );
  }
`, m = u.div`
  --skeletonBgColor0: ${(e) => e.theme.components.skeleton.gradientColor0};
  --skeletonBgColor1: ${(e) => e.theme.components.skeleton.gradientColor1};
  --skeletonBgColor2: ${(e) => e.theme.components.skeleton.gradientColor2};
  position: relative;
  color: transparent;
  background: linear-gradient(
    116.57deg,
    var(--skeletonBgColor1) 13.33%,
    var(--skeletonBgColor2) 102.5%
  );

  ${(e) => e.$animation && v`
      animation: ${h} 2000ms ease-in-out infinite;
    `}

  ${(e) => {
  if (e.$variant === "text")
    return C(e);
  {
    const t = B(e);
    return e.$variant === "circular" && (t.borderRadius = "50%"), e.$variant === "rounded" && (t.borderRadius = "8px"), t;
  }
}}
    & > * {
    visibility: hidden;
  }
`, y = ({
  variant: e = "text",
  height: t,
  width: a,
  animation: l = !0,
  children: i,
  textType: g = "headline",
  className: s,
  size: d
}) => /* @__PURE__ */ k(
  m,
  {
    $variant: e,
    $animation: l,
    height: t,
    width: a,
    className: s,
    $textType: g,
    size: d,
    children: i
  }
);
export {
  y as Skeleton
};
